module.exports = __webpack_public_path__ + "img/p2.6ea80e34.png";